var _path, _rect, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueYellowColorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 29,
    viewBox: "0 0 88 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H29.3333V29H4C1.79086 29 0 27.2091 0 25V4Z",
    fill: "#408CD2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    width: 29.3333,
    height: 29,
    fill: "#FFC52E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58 0H83.3333C85.5425 0 87.3333 1.79086 87.3333 4V25C87.3333 27.2091 85.5425 29 83.3333 29H58V0Z",
    fill: "#F3FF6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueYellowColorIcon);
export default __webpack_public_path__ + "static/media/BlueYellowColorIcon.1dd6403cbc6e9b6d6d95e9ec771bb689.svg";
export { ForwardRef as ReactComponent };